import { request } from "http";
import { RoleType } from "../../../../common/enum";
import { IRequestExpedient } from "../../../../models";
import { IInspection } from "../../../../models/requests/IEditRequest";
import { store } from "../../../../redux/store";

export const isShowActionsOfActuation = (organismInspectionId?: number) => {
    const { organismId, roles } = store.getState().userData.profile;
    const organism = store.getState().catalog.organisms;
    const viewOrganism = organism.data.find((x) => x.id === organismId);

    for (let rol of roles) {
        if (rol.id === RoleType.ORGANISM_ADMIN || rol.id === RoleType.ORGANISM_TECHNICIAN || rol.id === RoleType.ORGANISM_INSPECTOR || organismId) {
            return organismId === organismInspectionId || viewOrganism?.viewOrganismId === organismInspectionId;
        }
    }


    return true;
};

export const isShowAddActuation = (organismInspectionId?: number) => {
    return isShowActionsOfActuation(organismInspectionId);
};

export const isShowAddMultipleIcon = (requestExpedient: IRequestExpedient[], inspections: IInspection[]) => {
    const { roles, organismId } = store.getState().userData.profile;
    for (let rol of roles) {
        if (rol.id === RoleType.ORGANISM_ADMIN || rol.id === RoleType.ORGANISM_TECHNICIAN || rol.id === RoleType.ORGANISM_INSPECTOR || organismId ) {
            return inspections.length ? fetchIsOrganismToInspection(inspections) : fetchIsOrganismToInspection(requestExpedient);
        }
    }

    return true;
};

const fetchIsOrganismToInspection = (list: any[]) => {
    const { organismId } = store.getState().userData.profile;
    const organism = store.getState().catalog.organisms;

    if (list?.length) {
        for (let item of list) {
            const viewOrganism = organism.data.find((x) => x.id === organismId);
            if (item.organismId === organismId || viewOrganism?.viewOrganismId === item.organismId) {
                return true;
            }
        }
    }

    return false;
};
